namespace $.$$ {

	$mol_style_define( $shm_hitalama_map_selectbox, {

		zIndex: $mol_layer.float,
		transition: 'none',

		Outline_top: {
			background: {
				color: $mol_theme.current,
			},
		},

		Outline_left: {
			background: {
				color: $mol_theme.current,
			},
		},

		Outline_bottom: {
			background: {
				color: $mol_theme.current,
			},
		},

		Outline_right: {
			background: {
				color: $mol_theme.current,
			},
		},

		'[shm_hitalama_map_selectbox_dragged]': {
			true: {
				Outline_top: { background: { color: $mol_theme.focus } },
				Outline_left: { background: { color: $mol_theme.focus } },
				Outline_bottom: { background: { color: $mol_theme.focus } },
				Outline_right: { background: { color: $mol_theme.focus } },
			},
		},

		Count: {
			alignItems: 'center',
			justifyContent: 'center',
			minWidth: $mol_gap.block,
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			color: $mol_theme.shade,
		},

		Delete: {
			color: '#ff6666',
		},

	} )

}
